import { render, staticRenderFns } from "./ProviderList.vue?vue&type=template&id=376f682e&"
import script from "./ProviderList.vue?vue&type=script&lang=js&"
export * from "./ProviderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports